import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import GooglePublisherTag from '../components/GooglePublisherTag';
import config from 'config';
import {LOAD_ADVERTS} from "../middleware/tamGptInitialization";

const mapStateToProps = (state, props) => {
    const {
        common: {
          window: {isLoaded: windowIsLoaded = false} = {},
          tamGpt: {
            initializationComplete = false,
            tamAvailable = false,
            advertSlots = {}
          }
        } = {},
        auth: { loggedIn = false, user: { fullyregistered = false } = {} } = {}
    } = state;
    const { type:adType = null, routes: [, { lastRegisteredPath = "home" }] = [] } = props;
    const { enabled:adsEnabled = false } = config.googlePublisherTag;
    const targetParams = adType ? config.googlePublisherTag[adType] : {};

    return {
        ...props,
        windowIsLoaded,
        path: props.section ? props.section : lastRegisteredPath,
        fullyRegistered: (loggedIn ? fullyregistered : null),
        targetParams,
        adType,
        adsEnabled,
        isStagingEnv: config.staging,
        hostname: global.location ? global.location.hostname : 'www.sportinglife.com',
        initializationComplete,
        tamAvailable,
        advertSlots
    }
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAdverts: (slotId, slotSize, sizeMapping) => {
      dispatch({type: LOAD_ADVERTS, slotId, slotSize, sizeMapping})
    }
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GooglePublisherTag));



// WEBPACK FOOTER //
// ./modules/Common/containers/GooglePublisherTag.js